export default __webpack_public_path__ + "static/media/SJ.0b390185.jpg";